import { EnvironmentModel } from './environment.model'

export function env(): EnvironmentModel {
  return {
    stage: 'env-test',
    auth: {
      domain: 'dev-c4be3obj05th0lrq.eu.auth0.com',
      clientId: 'co0SMgyMtG6AiA5xWJuH82Z1qXkSZqK0',
      authorizationParams: {
        audience: 'https://tst-intern-backend.azurewebsites.net',
        scope: 'openid profile email offline_access',
        redirect_uri: window.location.origin,
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      httpInterceptor: {
        allowedList: ['https://tst-intern-backend.azurewebsites.net/api/*'],
      },
    },
    api: {
      internalUrl: 'https://tst-intern-backend.azurewebsites.net/api',
    },
    leistungserbringerWebappBaseUrl: 'https://one-tst.saniup.de',
    selfserviceWebappBaseUrl: 'https://versorgung-tst.saniup.de',
    selfserviceApiBaseUrl: 'https://tst-patienten-selfservice.azurewebsites.net',
  }
}
